<template>
  <div class="col mt-3">
    <!-- exit -->
    <div class="row d-flex justify-content-center">
      <button
        type="button"
        class="mt-3 m-3 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
      >
        <ToolTip text="Exit Races" position="right">
          <img :src="exitImg" @click="exitHandler()" height="48" width="48" alt="exit image" />
        </ToolTip>
      </button>
    </div>
    <!-- add race -->
    <div class="row d-flex justify-content-center">
      <button
        type="button"
        class="mt-3 m-3 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
        @click="showRacePanelHandler()"
      >
        <ToolTip text="Add Race" position="right">
          <span style="font-size: 45px">+</span>
        </ToolTip>
      </button>
    </div>
  </div>
</template>
        
<script>
import ToolTip from '../components/ToolTip.vue'
import exitImg from '../assets/images/bbExit100.png'
//==========================================================
// scripts
//---------
export default {
  name: 'RaceButtonsPanel',
  components: {
    ToolTip,
  },
  //==========================================================
  // data
  //------
  data() {
    return {
      exitImg,
    }
  },
  //==========================================================
  // methods
  //---------
  methods: {
    //--------------
    // exit handler
    //--------------
    exitHandler() {
      this.emitter.emit('exit-race-view')
    },
    //-------------------------
    // show race panel handler
    //-------------------------
    showRacePanelHandler() {
      this.emitter.emit('show-race-panel')
    },
  },
}
</script>
